import { isDefined } from 'app-shared/utils';

import { removeQueryStringFromSentryEvent } from '@/error-reporting/utils/removeQueryStringFromSentryEvent';

type SentryClient = {
  captureException: (error: unknown) => void;
};

let sentryClientPromise: Promise<SentryClient> | undefined;

// Sentry's code lives in its own chunk, downloaded once and only when error
// alerts are on, so it never weighs on the first page load. Only the two
// functions used are imported, so the chunk leaves out the rest of Sentry.
export const loadSentry = (dsn: string): Promise<SentryClient> => {
  if (!isDefined(sentryClientPromise)) {
    sentryClientPromise = import('@sentry/react').then(
      ({ captureException, init }) => {
        init({
          dsn,
          sendDefaultPii: false,
          beforeSend: removeQueryStringFromSentryEvent,
        });

        return { captureException };
      },
    );
  }

  return sentryClientPromise;
};
